<template>
  <div class="viewProject">
    <div class="basicInfo">
      <el-image
        style="width: 100px; height: 100px"
        :src="detailObj.projectCenterResult.companyLogoKey"
        fit="fit"
      />
      <div class="info">
        <el-descriptions :column="2" :colon="false">
          <el-descriptions-item :span="2" contentClassName="corporateName">
            {{ detailObj.projectCenterResult.corporateName }}
            <el-tag v-for="(el, i) in detailObj.projectCenterResult.industrys" :key="i">
              {{ el }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="总部地址：">
            {{ detailObj.projectCenterResult.companyCountry }}
            <span v-if="detailObj.projectCenterResult.companyProvince">-</span>
            {{ detailObj.projectCenterResult.companyProvince }}
            <span v-if="detailObj.projectCenterResult.companyCity">-</span>
            {{ detailObj.projectCenterResult.companyCity }}
          </el-descriptions-item>
          <el-descriptions-item label="主要联系人：">
            {{ detailObj.projectCenterResult.contacts }}&nbsp;
            {{ detailObj.projectCenterResult.post }}
          </el-descriptions-item>
          <el-descriptions-item label="公司简介：" :span="2">
            {{ detailObj.projectCenterResult.companyProfile }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="otherInfo">
      <el-descriptions :column="2" :colon="false">
        <el-descriptions-item label="招聘职位：" contentClassName="recruitmentPosition">
          {{ detailObj.projectCenterResult.recruitmentPosition }}
          <span v-if="detailObj.projectCenterResult.itemNo">
            [{{ detailObj.projectCenterResult.itemNo }}]
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="薪资范围：">
          {{ detailObj.projectCenterResult.isAnnual ? '年薪' : '月薪' }}
          {{ detailObj.projectCenterResult.wages }}~
          {{ detailObj.projectCenterResult.wagess }}
        </el-descriptions-item>
        <el-descriptions-item label="职位类型：">
          {{ detailObj.projectCenterResult.positionType }}
        </el-descriptions-item>
        <el-descriptions-item label="工作地点：">
          {{ detailObj.projectCenterResult.dutyStation }}
        </el-descriptions-item>
        <el-descriptions-item label="汇报对象：">
          {{ detailObj.projectCenterResult.reportingObject }}
        </el-descriptions-item>
      </el-descriptions>
      <div class="info">
        <div>职位描述：</div>
        <el-input
          style="width: 80%"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model="detailObj.projectCenterResult.jobDescription"
        />
      </div>
      <div class="info">
        <div>所需技能：</div>
        <el-input
          style="width: 80%"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model="detailObj.projectCenterResult.requiredSkills"
        />
      </div>
      <div class="info">
        <div>核心要求：</div>
        <el-input
          style="width: 80%"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model="detailObj.projectCenterResult.coreRequirements"
        />
      </div>
      <div v-for="(item, index) in detailObj.projectLeaderListResults" :key="index">
        <el-descriptions :colon="false">
          <el-descriptions-item label="项目顾问：">
            {{ item.projectLeader }}
          </el-descriptions-item>
          <el-descriptions-item label="联系方式：">
            {{ item.contactInformation }}
          </el-descriptions-item>
          <el-descriptions-item label="目标企业：">
            {{ item.targetEnterprise }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="info">
        <div>市场反馈：</div>
        <el-input
          style="width: 80%"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model="detailObj.projectCenterResult.marketFeedback"
        />
      </div>
      <div class="info">
        <div>项目评估：</div>
        <el-input
          style="width: 80%"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model="detailObj.projectCenterResult.projectEvaluation"
        />
      </div>
      <div class="time">
        <div>启动时间： {{ detailObj.projectCenterResult.startTime }}</div>
        <div>结束时间： {{ detailObj.projectCenterResult.endTime }}</div>
        <div class="updateTime">最近更新时间： {{ detailObj.projectCenterResult.updateTime }}</div>
      </div>
    </div>
    <icon-and-button
      class="edit"
      title="编辑"
      icon="icon-jr-icon-note"
      :iconStyle="{ color: '#17757A' }"
      :buttonStyle="{ color: '#17757A' }"
      @handleControl="handleControl"
    />
  </div>
</template>

<script>
import { getProjectCenterById } from '@/api/projectCenter'
import IconAndButton from '@/components/IconAndButton.vue'
export default {
  name: 'ViewProject',

  components: {
    IconAndButton
  },

  data() {
    return {
      value: '',
      detailObj: {
        projectCenterResult: {},
        projectLeaderListResults: []
      }
    }
  },

  computed: {
    id() {
      return Number(this.$route.query.id)
    },
    searchInfo() {
      return JSON.parse(this.$route.query.searchInfo)
    }
  },

  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)
    this.search()
  },

  methods: {
    async search() {
      const { data: res } = await getProjectCenterById({ id: this.id })
      if (res.resultCode === 200) {
        this.detailObj = res.data
      }
    },
    handleControl() {
      this.$router.push({
        name: 'AddEditprojectInfo',
        query: {
          id: this.id,
          type: 1
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.viewProject {
  position: relative;
  .basicInfo {
    background: #fff;
    padding: 16px;
    display: flex;
    margin-bottom: 16px;
    .info {
      max-width: 80%;
      margin-left: 20px;
    }
    /deep/ .corporateName {
      font-size: 18px;
      font-weight: 700;
      color: #1a1f33;
    }
  }
  .otherInfo {
    padding: 16px;
    background: #fff;
    /deep/ .recruitmentPosition {
      color: #1a1f33;
      font-size: 16px;
      font-weight: 700;
    }
    .info {
      font-size: 14px;
      color: #606266;
      margin-bottom: 10px;
      div {
        margin-bottom: 15px;
      }
    }
    .time {
      font-size: 14px;
      color: #1a1f33;
      div {
        padding: 2px 0;
      }
      .updateTime {
        font-size: 12px;
        color: #999999;
      }
    }
  }
  .edit {
    top: 15px;
    right: 10%;
    position: absolute;
  }
}
</style>
